// @flow
import { useId } from 'react';

import { useTranslator } from '@gandi/translate';
import { Badge, Tooltip, TooltipContainer } from '@gandi/ui';

import { useExpireDataInfo } from './modules';

type Props = {
  expiresOn: string,
};

export function ExpirationDateBadge({
  expiresOn,
}: Props): null | React.MixedElement {
  const translator = useTranslator();
  const { expireDate, expireTheme } = useExpireDataInfo(expiresOn);

  const id = useId();

  if (!expireDate) return null;

  return (
    <TooltipContainer
      id={`expire-date-${id}`}
      renderReference={getReferenceProps => (
        // $FlowFixMe[cannot-spread-inexact]
        <Badge intent={expireTheme} {...getReferenceProps()}>
          {expireDate}
        </Badge>
      )}
    >
      {getTooltipProps => (
        <Tooltip {...getTooltipProps()}>
          {translator.formatDate(expiresOn, 'LLLL')}
        </Tooltip>
      )}
    </TooltipContainer>
  );
}
